import { del } from '@/modules/transport/bms/components/judge/bmsModular';
import dayjs from 'dayjs';
import _ from 'lodash';

export default {
    data() {
        return {
            id: '',
            searchParams: {},
            loading: false,
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            totalData: [],
            selected: []
        };
    },
    methods: {
        // 查询
        queryList() {
            const params = { pageNo: this.pageNo, pageSize: this.pageSize, ...this.searchParams };
            const successCallback = (res) => {
                const data = res.data || res || {};
                this.totalData = (Array.isArray(data) && data) || data.list || [];
                this.pageTotal = data.totalCount || 0;
            };
            this.queryListExecute && this.queryListExecute({ params, successCallback });
        },
        // 分页
        handlePageChange(data) {
            this.pageNo = data;
            this.queryList();
        },
        // 分页大小
        handleSizeChange(data) {
            this.pageSize = data;
            this.queryList();
        },
        // 搜索
        handleSearchChange(data) {
            this.searchParams = data;
            this.pageNo = 1;
            this.queryList();
        },
        // 双击表格
        handleRowDBClick(row) {
            this.id = String(row.id);
            this.rowDBClickExecute && this.rowDBClickExecute(row);
        },
        // 多选
        handleSelectChange(data) {
            this.selected = [].concat(data);
        },
        // 启用
        handleStartUsing() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.selected.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else {
                const confirmFn = () => this.$confirm('是否确认启用？', '启用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                });
                const successCallback = () => {
                    this.$message.success('已启用');
                    this.queryList();
                };
                this.startUsingExecute && this.startUsingExecute({ confirmFn, params: { selected: this.selected }, successCallback });
            }
        },
        // 停用
        handleStopUsing() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.selected.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else {
                const confirmFn = () => this.$confirm('是否确认停用？', '停用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                });
                const successCallback = () => {
                    this.$message.success('已停用');
                    this.queryList();
                };
                this.stopUsingExecute && this.stopUsingExecute({ confirmFn, params: { selected: this.selected }, successCallback });
            }
        },
        // 删除
        handleDelete() {
            if (!this.selected.length) {
                this.$message.warning('请勾选数据');
                return;
            }
            const confirmFn = () => this.$confirm('您确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
            const successCallback = () => {
                this.$message.success('删除成功');
                this.pageNo = 1;
                this.queryList();
            };
            const ids = [];
            this.selected.forEach(li => { li.id && ids.push(li.id); });
            this.deleteTableConfirmExecute && this.deleteTableConfirmExecute({ confirmFn, params: { selected: this.selected, ids }, successCallback });
        },
        processTimeParam: parseConfigFormatTimeParamPatch
    },
    created() {
        this.initSearchParamsExecute && this.initSearchParamsExecute(this.searchParams);
        this.queryList();
    },
    mounted() {
    }
};

/**
 * @description 解析配置格式化时间的补丁函数(将日期时间选择组件supplierPanel的数据处理为查询参数)
 * @param params 查询参数
 * @param config  supplierPanel组件的config
 */
export function parseConfigFormatTimeParamPatch(config, params) {
    try {
        config = config || (this.config && this.config.searchList && this.config.searchList.searchTxt) ? this.config.searchList.searchTxt : [];
        const p = _.cloneDeep(params || this.searchParams);
        config.map(({ type, value, startTime, endTime }) => {
            if (type === 'time' && startTime && endTime) {
                if (value === 'searchTime') {
                    p[startTime] = p.startTime || '';
                    p[endTime] = p.endTime || '';
                    del(p, ['startTime', 'endTime', 'searchTime']);
                } else {
                    const t = p.value;
                    p[startTime] = Array.isArray(t) && t.length > 0 ? dayjs(t[0]).format('YYYY-MM-DD HH:mm:ss') : '';
                    p[endTime] = Array.isArray(t) && t.length > 0 ? dayjs(t[1]).format('YYYY-MM-DD HH:mm:ss') : '';
                    del(p, [value]);
                }
            }
        });
        return p;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(config);
    }
}